import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import LegalPage from './pages/LegalPage';
import ProPage from './pages/ProPage';

function App() {
    return (
        <Router basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/mentions-legales" element={<LegalPage />} />
                <Route path="/espace-pro" element={<ProPage />} />
            </Routes>
        </Router>
    );
}

export default App;